export default __webpack_public_path__ + "static/media/bkg--design-1.c6cbe7d1.jpg";